import React from "react";
import { Button, Tooltip } from "@mui/material";
import { ReactComponent as SourcesLibraryIcon } from "../../assets/icons/Sources-Light.svg";
import { ReactComponent as SourcesLibraryIconDark } from "../../assets/icons/Sources-Dark.svg";

/**
 * Props for the SearchToggle component.
 */
interface SearchToggleProps {
  /** Whether the search is currently on. */
  isSearchOn: boolean;
  /** Callback function to toggle the search state. */
  onToggleSearch: () => void;
  /** Custom styles for the component. */
  styles: any;
  /** Whether the search toggle is disabled. */
  disabled: boolean;
}

/**
 * A toggle button that enables or disables search functionality.
 */
const SearchToggle: React.FC<SearchToggleProps> = ({
  isSearchOn,
  onToggleSearch,
  styles,
  disabled,
}) => {
  // Determine the tooltip text based on the search state
  const tooltipText = isSearchOn
    ? "Toggle off to chat without searching sources"
    : "Toggle on to receive relevant sources in response";

  const tootipDisabledText = "Coming soon: search sources with attachments.";

  return (
    <Tooltip
      title={disabled ? tootipDisabledText : tooltipText}
      placement="bottom"
    >
      <span>
        <Button
          onClick={onToggleSearch} // Call the toggle function when the button is clicked
          sx={styles.searchButton(isSearchOn)} // Apply styles based on the search state
          disableRipple // Disable the ripple effect on click
          startIcon={
            isSearchOn ? <SourcesLibraryIcon /> : <SourcesLibraryIconDark />
          } // Add the SourcesLibraryIcon as the start icon
          disabled={disabled}
        >
          Search Sources
        </Button>
      </span>
    </Tooltip>
  );
};

export default SearchToggle;
